import {Mixin} from "../../../../mixin";

const set = key => (state, val) => {
    state[key] = val
}

function initialState() {
    return {
        tutorials: [],
        popups: [],
        popupSlugs: [],
        data: [],
        total: 0,
        query: {},
        loading: false
    }
}

const route = 'categories'

const getters = {
    tutorials: state => state.tutorials,
    popups: state => state.popups,
    popupSlugs: state => state.popupSlugs,
    data: state => state.data,
    total: state => state.total,
    loading: state => state.loading
}

const actions = {
    fetchIndexData({commit, state}) {
        commit('setLoading', true)

        Mixin.methods.request_ApiGet('permission', state.query)
            .then(response => {
                commit('setData', response.data.data)
                commit('setTotal', response.data.total)
            })
            .catch(error => {
                // message = error.response.data.message || error.message
                // TODO error handling
            })
            .finally(() => {
                commit('setLoading', false)
            })


    },
    destroyData({commit, state, dispatch}, id) {
        axios
            .delete(`${route}/${id}`)
            .then(response => {
                dispatch('fetchIndexData')
            })
            .catch(error => {
                message = error.response.data.message || error.message
                // TODO error handling
            })
    },

    setTutorials({commit, state}) {
        commit('setLoading', true)

        Mixin.methods.request_ApiGet('allTutorials')
            .then(response => {
                commit('setTutorial', response.data.slugTutorials)
                commit('setpopupSlugs', response.data.slugPopups)
                commit('setpopups', response.data.popups)
            })
            .catch(error => {
                // message = error.response.data.message || error.message
                // TODO error handling
            })
            .finally(() => {
                commit('setLoading', false)
            })


    },

    setQuery({commit}, value) {
        commit('setQuery', _.cloneDeep(value))
    },
    resetState({commit}) {
        commit('resetState')
    }
}

const mutations = {
    setData: set('data'),
    setpopupSlugs: set('popupSlugs'),
    setpopups: set('popups'),
    setTutorial: set('tutorials'),
    setTotal: set('total'),
    setQuery(state, query) {
        query.page = (query.offset + query.limit) / query.limit
        state.query = query
    },
    setLoading: set('loading'),
    resetState(state) {
        Object.assign(state, initialState())
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
